module.exports = __webpack_public_path__ + "img/tower_rain.e856ed9b.jpg";